import { IGameIdentityDTO } from "motw_core/DTOs/IGameIdentityDTO";
import { ERPGIcon } from "motw_core/UI/Icons/ERPGIcon";
import * as React from "react";
import { RPGIconSelector } from "source/app/presentation/Shared/RPGIcon/RPGIconSelector/RPGIconSelector";
import Data from "source/app/services/Data";
import { resourceNameGameIdentity } from "../../../../../../../../motw_core/Entity/IGameIdentity";
import { GetEnumNames } from "../../../../../../../../motw_core/Utils/EnumUtils";
import { IGameIdentityScoresState } from "../../GameIdentityScores";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";

export function IdentityIconPicker({
    identity,
}: {
    identity: IGameIdentityDTO;
}) {
    const [currentIcon, setCurrentIcon] = React.useState<string>(
        ERPGIcon[identity.erpgicon]
    );

    return (
        <div>
            <RPGIconSelector
                OnSelect={async (iconName) => {
                    setCurrentIcon(iconName);

                    const enumNames = GetEnumNames(ERPGIcon);
                    const iconNumber = enumNames.findIndex(
                        (name) => name === iconName
                    )!;

                    await ClientDataProvider.UpdateRecordAsync(
                        `${resourceNameGameIdentity}?id=eq.${identity.id}`,
                        { erpgicon: iconNumber }
                    );

                    await Data.Load.Single.ByStateTarget<IGameIdentityScoresState>(
                        `gameIdentityScores`
                    );
                }}
                currentIconName={currentIcon}
            />
        </div>
    );
}
